import React from 'react'
import Banner from '../MyComponent/Banner'

function BuildYour() {
  return (
    <div>
      <Banner />
    </div>
  )
}

export default BuildYour
